export var CheckinStep;
(function (CheckinStep) {
    CheckinStep["Passengers"] = "";
    CheckinStep["Meal"] = "meal";
    CheckinStep["Upgrade"] = "upgrade";
    CheckinStep["Baggage"] = "baggage";
    CheckinStep["Seats"] = "seats";
    CheckinStep["Insurance"] = "insurance";
    CheckinStep["Extras"] = "extras";
    CheckinStep["Restrictions"] = "restrictions";
    CheckinStep["Payment"] = "payment";
})(CheckinStep || (CheckinStep = {}));
